import "./suporte.eec4cfaa.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8648"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8648"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $6KOho = parcelRequire("6KOho");
const $53ea64db4c8dc927$var$q = new URLSearchParams(window.location.search);
const $53ea64db4c8dc927$var$code = $53ea64db4c8dc927$var$q.get('j') || '';
const $53ea64db4c8dc927$var$decoded = atob($53ea64db4c8dc927$var$code) || false;
const $53ea64db4c8dc927$var$obj = JSON.parse($53ea64db4c8dc927$var$decoded) || false;
document.body.innerHTML = document.body.innerHTML.replace(/{{nick}}/g, $53ea64db4c8dc927$var$obj.nick);
if ($53ea64db4c8dc927$var$obj.mode === '1x1') document.getElementById('root-team').style.display = 'none';
if ($53ea64db4c8dc927$var$obj.winning_value) document.body.innerHTML = document.body.innerHTML.replace(/{{winning_value}}/g, 'R$ ' + $53ea64db4c8dc927$var$obj.winning_value + '!');
else document.body.innerHTML = document.body.innerHTML.replace(/{{winning_value}}/g, "gr\xe1tis");
function $53ea64db4c8dc927$var$getUrl() {
    if (!$53ea64db4c8dc927$var$obj.room_id) return 'clubedotruco://' + $53ea64db4c8dc927$var$code;
    var o = {
        room_id: $53ea64db4c8dc927$var$obj.room_id,
        team: document.getElementById('team').value
    };
    var str = btoa(JSON.stringify(o));
    return 'clubedotruco://' + str;
}
$6KOho(function() {
    const noCode = $6KOho('#no-code');
    const withCode = $6KOho('#with-code');
    $6KOho('#close-dialog').on('click', function(event) {
        event.preventDefault();
        $6KOho('#dialog-error').hide();
    });
    if ($53ea64db4c8dc927$var$obj) withCode.removeClass('hidden');
    else noCode.removeClass('hidden');
    $6KOho('#join').attr('href', $53ea64db4c8dc927$var$getUrl());
});


//# sourceMappingURL=mp.1d3b0fc2.js.map
